<ion-header>
  <ion-toolbar>
    <ion-title color="danger">Permanent Account Deletion</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p>Are you sure you wish to delete your account? This can not be undone.</p>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">Cancel</ion-button>
      <ion-button color="danger" (click)="confirm()">Delete</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
